<template>
    <div class="section-title-wrapper">
        <h2 class="page-title"><slot /></h2>
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.section-title-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
}
.page-title {
    font-size: 15px;
    font-weight: 600;
    color: $gray800;
    letter-spacing: -0.01em;
    position: relative;
    padding-left: 12px;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 18px;
        background: $primaryColor;
        border-radius: 2px;
    }
}
</style>
